import { apiPost } from "./api";

export default class ServicioVisita {
	static guardarAntropometria(visitaId, datos) {
		const data = {
			VisitaID: visitaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/visita/Antropometria", data);
	}
	static guardarBioquimicos(visitaId, datos) {
		const data = {
			VisitaID: visitaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/visita/Bioquimicos", data);
	}

	static guardarClinicos(visitaId, datos) {
		const data = {
			VisitaID: visitaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/visita/Clinicos", data);
	}

	static guardarDieteticosEstiloVida(visitaId, datos) {
		const data = {
			VisitaID: visitaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/visita/DieteticosEstiloVida", data);
	}

	static guardarAnalisisPlanTerapeutico(visitaId, datos) {
		const data = {
			VisitaID: visitaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/visita/AnalisisPlanTerapeutico", data);
	}

	static guardarNotaEvolucionInterna(visitaId, datos) {
		const data = {
			VisitaID: visitaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/visita/NotaEvolucionInterna", data);
	}

	static guardarNotaEvolucionFirma(visitaId, datos) {
		const data = {
			VisitaID: visitaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/visita/NotaEvolucionFirma", data);
	}

	static guardarNotaEvolucionMedico(visitaId, datos) {
		const data = {
			VisitaID: visitaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/visita/NotaEvolucionMedico", data);
	}

	static obtenerInfoPaso(paso, visitaId) {
		return apiPost(`/visita/${paso}/ObtenerInfo`, { VisitaID: visitaId });
	}

	static obtenerInfoPaciente(visitaId) {
		return apiPost(`/visita/Paciente/ObtenerInfo`, { VisitaID: visitaId });
	}
}
